/** Shared layout + surface tokens for /account area */
export const ACCOUNT_ACCENT = {
  bar: 'bg-[#1a1d24]',
  pageBg: 'bg-gradient-to-b from-[#c5d2e3] via-[#d9e2ef] to-[#e6edf6]',
  pageWash:
    'before:pointer-events-none before:absolute before:inset-0 before:bg-[radial-gradient(ellipse_100%_60%_at_50%_-15%,rgba(43,108,255,0.18),transparent_58%)]',
  activeSidebar: 'bg-sky-50 border-l-[3px] border-l-[#2b6cff]',
  cardSurface:
    'border border-slate-200/90 bg-white shadow-md shadow-slate-900/[0.06] ring-1 ring-white/60'
} as const;

export const accountModalAuthButtonClass =
  'rounded-lg bg-[#2b6cff] px-5 py-2.5 text-sm font-semibold text-white hover:bg-[#2563eb] transition-colors';

/** High-contrast table / cart checkboxes (on state easy to see). */
export const ACCOUNT_TABLE_CHECKBOX_CLASS =
  'h-4 w-4 shrink-0 cursor-pointer rounded border-2 border-slate-500 bg-white text-[#2b6cff] accent-[#2b6cff] shadow-sm checked:border-[#2b6cff] checked:bg-[#2b6cff] focus:ring-2 focus:ring-[#2b6cff]/35 focus:ring-offset-1 disabled:cursor-not-allowed disabled:opacity-50';
